import Api from './api';

const slug = 'v1/scripts';
export default {
  generateScript(topic, words, language, tempUser, demoToken, program) {
    return new Promise((resolve, reject) => {
      Api.post(`/${slug}/generate/`, {
        topic, words, language, tempUser, demoToken, program,
      })
        .then(res => resolve(res.data))
        .catch((err) => {
          reject(err);
        });
    });
  },
  refineScript(currentText, instructions, language, program) {
    return new Promise((resolve, reject) => {
      Api.post(`/${slug}/refine/`, {
        currentText, instructions, language, program,
      })
        .then(res => resolve(res.data))
        .catch((err) => {
          reject(err);
        });
    });
  },
  optimizeTranscript(videoId, data) {
    return new Promise((resolve, reject) => {
      Api.post(`/${slug}/optimise/${videoId}`, data)
        .then(res => resolve(res.data))
        .catch((err) => {
          reject(err);
        });
    });
  },
  getScripts(lang) {
    return new Promise((resolve, reject) => {
      Api.get(`/${slug}/`, {
        params: {
          language: lang,
        },
      })
        .then(res => resolve(res.data))
        .catch((err) => {
          reject(err);
        });
    });
  },
  getCategories() {
    return new Promise((resolve, reject) => {
      Api.get(`/${slug}/categories/`, {
      })
        .then(res => resolve(res.data))
        .catch((err) => {
          reject(err);
        });
    });
  },
  createScript(script) {
    return new Promise((resolve, reject) => {
      Api.post(`/${slug}/`, script)
        .then(res => resolve(res.data))
        .catch((err) => {
          reject(err);
        });
    });
  },
  updateScript(script) {
    return new Promise((resolve, reject) => {
      Api.put(`/${slug}/${script._id}`, script)
        .then(res => resolve(res.data))
        .catch((err) => {
          reject(err);
        });
    });
  },
  deleteScript(script) {
    return new Promise((resolve, reject) => {
      Api.delete(`/${slug}/${script._id}`)
        .then(res => resolve(res.data))
        .catch((err) => {
          reject(err);
        });
    });
  },
};
